import { Injectable } from '@angular/core';
import { CanActivate,  UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardestudiantesGuard implements CanActivate {
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let rol = localStorage.getItem('rol');

    if(rol==="3"){ //rol de estudiantes
      return true;
    }
    return false;

  }

}
